import { Api } from 'models/services/api';
import { ReadOriginalIngredientCategoriesQuery } from 'models/services/graphql';

import { OriginalIngredientCategoryCollectionData } from '../collection';

type DataToRead = {
  nextToken?: string;
};

const RequestQuery = `
  query ReadOriginalIngredientCategories($nextToken: String) {
    ${ReadOriginalIngredientCategoriesQuery}
  }
`;

type ResponseData = {
  data: {
    readOriginalIngredientCategories: OriginalIngredientCategoryCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: OriginalIngredientCategoryCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToRead = {}): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readOriginalIngredientCategories;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };